import { useDealer } from "src/hooks/useDealer";
import {
  Container,
  IndicatorNub,
  Content,
  IconWrapper,
  Title,
} from "./MenuItem.styles";
import {
  FilesIcon,
  FilesSelectedIcon,
  EmailIcon,
  Mail01,
} from "src/assets/icons";

interface MenuItemProps {
  forPage: string;
  isCurrent: boolean;
  isCollapsed: boolean;
}

const data = {
  "pre-approval": {
    href: "pre-approval",
    title: "Pre-Approval",
    icon: FilesIcon,
    selectedIcon: FilesSelectedIcon,
  },
  "conditions-inbox": {
    href: "conditions-inbox",
    title: "Conditions Inbox",
    icon: EmailIcon,
    selectedIcon: Mail01,
  },
  rcm: {
    href: "rcm",
    title: "Contact Manager",
    icon: FilesIcon,
    selectedIcon: FilesSelectedIcon,
  },
};

export default function ({ forPage, isCurrent, isCollapsed }: MenuItemProps) {
  const Icon = isCurrent
    ? data[forPage as keyof typeof data].selectedIcon
    : data[forPage as keyof typeof data].icon;
  return (
    <Container to={`/${data[forPage as keyof typeof data].href}`}>
      <IndicatorNub isCurrent={isCurrent} />
      <Content isCurrent={isCurrent} isCollapsed={isCollapsed}>
        <IconWrapper>
          <Icon />
        </IconWrapper>
        <Title isCollapsed={isCollapsed}>
          {data[forPage as keyof typeof data].title}
        </Title>
      </Content>
    </Container>
  );
}
